import authAxios from "../authAxios";

const BASE = "/v1/courses";

export const listCourses = () => authAxios.get(BASE);

export const getCourse = (slug) => authAxios.get(`${BASE}/${slug}`);

export const getEnrollment = (slug) => authAxios.get(`${BASE}/${slug}/enrollment`);

export const updateEnrollment = (slug, data) => authAxios.put(`${BASE}/${slug}/enrollment`, data);

export const completeCourse = (slug, answers) =>
  authAxios.post(`${BASE}/${slug}/complete`, { answers });

export const submitSection = (slug, sectionId, answers) =>
  authAxios.post(`${BASE}/${slug}/submit-section`, { section_id: sectionId, answers });

// Admin
export const createCourse = (data) => authAxios.post(BASE, data);

export const parseDeck = (deckUrl) =>
  authAxios.post(`${BASE}/parse-deck`, { deckUrl });

export const updateCourseById = (id, data) => authAxios.put(`${BASE}/${id}/update`, data);

export const archiveCourse = (id) => authAxios.delete(`${BASE}/${id}`);

export const deleteCourse = (id) => authAxios.delete(`${BASE}/${id}/permanent`);

export const duplicateCourse = (id, data) => authAxios.post(`${BASE}/${id}/duplicate`, data);

export const reorderSections = (courseId, orderedIds) =>
  authAxios.put(`${BASE}/${courseId}/reorder-sections`, { orderedIds });

export const addSection = (courseId, data) => authAxios.post(`${BASE}/${courseId}/sections`, data);

export const updateSection = (sectionId, data) =>
  authAxios.put(`${BASE}/sections/${sectionId}`, data);

export const deleteSection = (sectionId) => authAxios.delete(`${BASE}/sections/${sectionId}`);

export const reorderQuestions = (sectionId, orderedIds) =>
  authAxios.put(`${BASE}/sections/${sectionId}/reorder-questions`, { orderedIds });

export const addQuestion = (sectionId, data) =>
  authAxios.post(`${BASE}/sections/${sectionId}/questions`, data);

export const updateQuestion = (questionId, data) =>
  authAxios.put(`${BASE}/questions/${questionId}`, data);

export const deleteQuestion = (questionId) => authAxios.delete(`${BASE}/questions/${questionId}`);

// Admin - enrollments
export const listEnrollments = (slug) => authAxios.get(`${BASE}/${slug}/enrollments`);

export const getEnrollmentAttempts = (slug, enrollmentId) =>
  authAxios.get(`${BASE}/${slug}/enrollments/${enrollmentId}/attempts`);
